// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useState } from "react";

export function useScriptCode(code: string, addToHead: boolean) {
    const [status, setStatus] = useState<"loading" | "idle" | "ready" | "error">(
        code ? "loading" : "idle"
    );

    const hashCode = (str: string): string => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash * 32) - hash) + char; 
            hash = Math.trunc(hash);
        }
        return Math.abs(hash).toString();
    };

    useEffect(() => {
        if (!code) {
            setStatus("idle");
            return;
        }

        // Create a unique identifier for the script based on its content
        const scriptId = `inline-script-${hashCode(code)}`;
        let script: HTMLScriptElement | null = document.getElementById(scriptId) as HTMLScriptElement;

        if (!script) {
            script = document.createElement("script");
            script.id = scriptId;
            script.text = code;
            script.type = "text/javascript";
            script.setAttribute("data-status", "loading");

            if (addToHead) {
                document.head.appendChild(script);
            } else {
                document.body.appendChild(script);
            }

            // For inline scripts, we assume they load immediately
            script.setAttribute("data-status", "ready");
            setStatus("ready");
        } else {
            setStatus(script.getAttribute("data-status") as any || "ready");
        }
    }, [code]);

    return status;
}
